// @flow
import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import { m } from 'framer-motion';
var _Wrapper = styled(m.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: calc(", ");\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n"], ["\n  padding-left: calc(", ");\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  min-width: 0;\n"])), function (_a) {
    var level = _a.level;
    return "25px * " + level;
});
var Wrapper = function (_a) {
    var level = _a.level, children = _a.children;
    return React.createElement(_Wrapper, { level: level }, children);
};
Wrapper.defaultProps = {
    level: 0
};
export default Wrapper;
var templateObject_1;
//# sourceMappingURL=Wrapper.js.map